import Vue from 'vue'
import { Toast, Icon, Lazyload, List, Dialog } from 'vant'
// 引入图片hook函数
import { imageUrlHook } from '../utils/func/imageUrlHook'

// 按需使用vant组件(全局)
Vue.use(Toast)
Vue.use(Icon)
Vue.use(List)
Vue.use(Dialog)
Vue.use(Lazyload, {
  loading: imageUrlHook('https://ws1.sinaimg.cn/large/006Pg1gLgy1g7u7vx69oug308c0go1ky.gif'),
  error: imageUrlHook('https://ws1.sinaimg.cn/large/006Pg1gLgy1g7u82vq2lsj308c0goa9z.jpg')
})
